import FuneralNotice from '../FuneralNotice.vue'

export default [
    {
        path: '/admin_funeral_notice',
        name: '/admin_funeral_notice',
        component: FuneralNotice,
        meta: {
            layout: 'admin-layout'
        }
    }
]